import { Typographies } from '@/theme';
import { styled } from '@mui/material';

interface TitleStyledProps {
  attrs: { active: boolean; filled: boolean; clickable?: boolean };
}

export const TitleStyled = styled('div')<TitleStyledProps>(
  ({ theme, attrs: { filled } }) => ({
    borderBottom: filled ? `1px solid ${theme.palette.dark.dark_2}` : 'none',
  }),
);

export const TitleCardStyled = styled('div')<TitleStyledProps>(
  ({ theme, attrs: { active, clickable } }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    fontWeight: Typographies.FONT_WEIGHT_H4,
    color: active ? theme.palette.white.main : theme.palette.dark.dark_2,
    backgroundColor: active ? theme.palette.primary.main : 'inherit',
    borderRadius: theme.spacing(9),
    padding: theme.spacing(1.4, 3),
    cursor: clickable ? 'pointer' : 'default',
  }),
);
